module.exports = __webpack_public_path__ + "img/xxshicon.8aba1c18.svg";